import qs from 'qs'
import HttpBase from './base'

const defaultConfig = {
  // throwHttpErrors: false,
  parseJson(res) {
    try {
      return JSON.parse(res)
    } catch (e) {
      console.error('[解析请求的 JSON 出错]', res)
      return null
    }
  },
  timeout: 180000,
  hooks: {},
}

const ensureToken = (originUrl, config = { searchParams: {} }) => {
  const [path, search] = originUrl.split('?')
  const searchParams = {
    ...qs.parse(search),
    ...config.searchParams,
  }

  return {
    ...config,
    url: path,
    searchParams,
  }
}

export function setDefaultConfig(config) {
  Object.assign(defaultConfig, config)
}

export default class Offline extends HttpBase {
  get http() {
    return this.dataFetcher
  }

  request(url, config, method = 'GET') {
    const extendedConfig = ensureToken(url, config)
    const req = Promise.resolve(
      this.http({
        ...extendedConfig,
        method,
      })
    )

    console.log('[4]', req)

    req.json = () => {
      return Promise.resolve(req)
    }
    req.text = () => {
      return Promise.resolve(req)
    }
    return req
  }

  head(url, config) {
    return this.request(url, config, 'HEAD')
  }

  get(url, config) {
    return this.request(url, config)
  }

  delete(url, data, config) {
    return this.request(url, { ...config, json: data }, 'DELETE')
  }

  post(url, data, config) {
    if (data) {
      return this.request(url, { ...config, json: data }, 'POST')
    }
    return this.request(url, config, 'POST')
  }

  put(url, data, config) {
    return this.request(url, { ...config, json: data }, 'PUT')
  }

  patch(url, data, config) {
    return this.request(url, { ...config, json: data }, 'PATCH')
  }
}
